export default __webpack_public_path__ + "f7c5cc380af592dc891e7638b6af4824.svg";